import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const VehiclesService = {
  list: (filter = []) => axios.post(API_URL + "/vehicles/get/vehicles-list", filter).then(({ data }) => data.data).catch((err) => { throw err }),
  getById: (id) => axios.get(API_URL + `/vehicles/${id}`).then(({ data }) => data).catch((err) => { throw err }),
  getReviewsItemsByVehicleId: (id) => axios.get(API_URL + `/vehicles/get/reviewItemsById/${id}`).then(({ data }) => data.data).catch((err) => { throw err }),
  getVehicleDamage: (data) => axios.post(API_URL + `/vehicles/get/damage`, data).then(({ data }) => data.data).catch((err) => { throw err }),
  save: (payload) => axios.post(API_URL + `/vehicles`, payload).then(({ data }) => data.data).catch((err) => { throw err }),
  update: (id, payload) => axios.put(API_URL + `/vehicles/${id}`, payload).then(({ data }) => data.data).catch((err) => { throw err }),
};

export default VehiclesService;